import { Asterisk } from "lucide-react";

const items = [
  "VISION",
  "BLUEPRINT",
  "QUANTUM HABITS™",
  "CAPACITY",
  "CURRENCY™",
  "MORE LIFE",
  "PLEASURE IS PART OF THE PLAN",
  "WILDLY YOURS",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-coal py-4">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} aria-hidden={dup === 1} className="flex items-center">
          {items.map((t) => (
            <span key={`${dup}-${t}`} className="flex items-center font-mono text-[11px] tracking-[0.35em] text-cream/50">
              <span className="px-6">{t}</span>
              <Asterisk className="h-4 w-4 text-lime" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
